import React from "react";
import { Skeleton, Box } from "@mui/material";

interface TaskTableSkeletonProps {
    pageSize?: number;
}

export const TaskTableSkeleton: React.FC<TaskTableSkeletonProps> = ({
    pageSize = 12,
}) => {
    return (
        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
            {/* Header Skeleton */}
            <Box
                sx={{
                    height: 48,
                    borderBottom: "1px solid #e2e8f0",
                    display: "flex",
                    alignItems: "center",
                    px: 2,
                    gap: 2,
                }}
            >
                <Skeleton variant="text" width="20%" height={20} />
                <Skeleton variant="text" width="15%" height={20} />
                <Skeleton variant="text" width="8%" height={20} />
                <Skeleton variant="text" width="10%" height={20} />
                <Skeleton variant="text" width="8%" height={20} />
                <Skeleton variant="text" width="6%" height={20} />
                <Skeleton variant="text" width="6%" height={20} />
                <Skeleton variant="text" width="20%" height={20} />
            </Box>

            {/* Rows Skeleton */}
            {Array.from({ length: pageSize }).map((_, i) => (
                <Box
                    key={i}
                    sx={{
                        height: 72,
                        borderBottom: "1px solid #f1f5f9",
                        display: "flex",
                        alignItems: "center",
                        px: 2,
                        gap: 2,
                    }}
                >
                    {/* Task Column (flex: 2, minWidth: 220) */}
                    <Box
                        sx={{
                            flex: "2 1 220px",
                            minWidth: 220,
                            display: "flex",
                            flexDirection: "column",
                            gap: 0.5,
                        }}
                    >
                        <Skeleton variant="text" width="85%" height={18} />
                        <Skeleton variant="text" width="60%" height={16} />
                    </Box>

                    {/* Assigned To Column (flex: 1, minWidth: 180) */}
                    <Box
                        sx={{
                            flex: "1 1 180px",
                            minWidth: 180,
                            display: "flex",
                            alignItems: "center",
                            gap: 1.5,
                        }}
                    >
                        <Skeleton variant="circular" width={32} height={32} />
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 0.5,
                            }}
                        >
                            <Skeleton variant="text" width={100} height={16} />
                            <Skeleton variant="text" width={80} height={14} />
                        </Box>
                    </Box>

                    {/* Count Column (width: 100) */}
                    <Box
                        sx={{
                            width: 100,
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <Skeleton variant="circular" width={24} height={24} />
                    </Box>

                    {/* Status Column (width: 130) */}
                    <Box
                        sx={{
                            width: 130,
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <Skeleton variant="rounded" width={80} height={24} />
                    </Box>

                    {/* Completed Column (width: 100) */}
                    <Box
                        sx={{
                            width: 100,
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <Skeleton variant="circular" width={24} height={24} />
                    </Box>

                    {/* Valid Column (width: 80) */}
                    <Box
                        sx={{
                            width: 80,
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <Skeleton variant="circular" width={24} height={24} />
                    </Box>

                    {/* Invalid Column (width: 80) */}
                    <Box
                        sx={{
                            width: 80,
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <Skeleton variant="circular" width={24} height={24} />
                    </Box>

                    {/* Actions Column (flex: 1, minWidth: 250) */}
                    <Box
                        sx={{
                            flex: "1 1 250px",
                            minWidth: 250,
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                        }}
                    >
                        <Skeleton variant="circular" width={32} height={32} />
                        <Skeleton variant="circular" width={32} height={32} />
                        <Skeleton variant="circular" width={32} height={32} />
                        <Skeleton variant="circular" width={32} height={32} />
                    </Box>
                </Box>
            ))}
        </div>
    );
};
